import * as types from './actionTypes';
import {apiRequest, apiPost} from '../utils/request';
import {toastr} from 'react-redux-toastr';
import {ROLE_SuperUser} from "../constants";

export function loadUnmappedSuburbsSuccess(unmappedSuburbs){
  return {type: types.LOAD_SUBURBS_UNMAPPED_SUCCESS, unmappedSuburbs};
}

export function saveSuburbsToRegionSuccess(suburb, regionId){
  return {type: types.SAVE_SUBURBS_TOREGION_SUCCESS, suburb, regionId};
}

export function removeSuburbFromRegionSuccess(suburb, regionId){
  return {type: types.REMOVE_SUBURB_FROMREGION_SUCCESS, suburb, regionId};
}

export function loadUnmappedSuburbs() {
  return function (dispatch, getState) {
    let account = getState().account;

    if(!account || !account.user || !account.user.hasRole(ROLE_SuperUser)){
      return;
    }

    return apiRequest(`/api/suburbs/unassignedtoregion`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while fetching unmapped suburbs, error: ${x.error ? x.error : x.data.Message}`);
          dispatch(loadUnmappedSuburbsSuccess({loaded: true, items: []}));
        } else {
          let items = [...x.data];
          if(items.length > 0){
            toastr.warning(`There are ${items.length} unmapped suburb(s), please map them in region management`);
          }
          dispatch(loadUnmappedSuburbsSuccess({loaded: true, items}));
        }
      });
  };
}


export function saveSuburbToRegion(suburb, regionId) {
  return function (dispatch) {
    toastr.success('Saving...');
    return apiPost(`/api/suburbs/${suburb.id}/assignToRegion/${regionId}`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error saving suburb to region, error: ${x.error ? x.error : x.data.Message}`);
        } else {
          dispatch(saveSuburbsToRegionSuccess(suburb, regionId));
        }
      });
  };
}

export function removeSuburbFromRegion(suburb, regionId) {
  return function (dispatch) {
    toastr.success('Saving...');
    return apiPost(`/api/suburbs/${suburb.id}/unassignFromRegion/${regionId}`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error saving suburb to region, error: ${x.error ? x.error : x.data.Message}`);
        } else {
          dispatch(removeSuburbFromRegionSuccess(suburb, regionId));
        }
      });
  };
}
